import { defineStore } from 'pinia';
import type { AlternativeProductsModalState } from '~~/types/vuex/AlternativeProductsModal';

export const alternativeProductsModalStore = defineStore('alternativeProductsModal', {
  state: () => ({ alternativeProductsModalState: null as AlternativeProductsModalState['alternativeProductsModalState'] | null }),
  actions: {
    setAlternativeProductsModalState(payload: AlternativeProductsModalState['alternativeProductsModalState'] | null) {

      this.alternativeProductsModalState = payload; 

    },
  },
});
